/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawer_itemSearch = {
    readonly pageType: string | null;
    readonly totalResults: number | null;
    readonly filters: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_filters" | "SbSharedRefineMenuDisplayPrefsSelect_filters">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_itemSearch" | "SbRespSortItems_itemSearch" | "SbSharedRefineMenuSearchWithin_itemSearch" | "SbRespRefineMenuDrawerHeader_itemSearch" | "SbRespRefineMenuFilterSortFacet_itemSearch" | "SbSharedRefineMenuDisplayPrefsSelect_itemSearch">;
    readonly " $refType": "SbRespRefineMenuDrawer_itemSearch";
};
export type SbRespRefineMenuDrawer_itemSearch$data = SbRespRefineMenuDrawer_itemSearch;
export type SbRespRefineMenuDrawer_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuDrawer_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawer_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuDrawer_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "filters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseFilter",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SbSharedRefineMenuFilters_filters",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedRefineMenuDisplayPrefsSelect_filters",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuSearchWithin_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawerHeader_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterSortFacet_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '378f0c6e62d6aba9346cd12c30e943e2';
export default node;
